const Tag = (api: any) => ({
  getTags: () => api.get("/tag/getTags.php", {}, {}),
  });
  
  export default Tag;
  